export const en = {
  emptyTitle: 'Add a title',
  generateTitleTooltip: 'Generate a title suggestion using AI'
};

export type Translations = typeof en;
